import { render, staticRenderFns } from "./OrdersSelectorMobile.vue?vue&type=template&id=4752cb28&scoped=true"
import script from "./OrdersSelectorMobile.vue?vue&type=script&lang=js"
export * from "./OrdersSelectorMobile.vue?vue&type=script&lang=js"
import style0 from "./OrdersSelectorMobile.vue?vue&type=style&index=0&id=4752cb28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4752cb28",
  null
  
)

export default component.exports